$(document).ready(function() {
    let youTubeVideoPlayed = false;
    $(window).on('blur', function() {
        setTimeout(function() {
            if (document.activeElement instanceof HTMLIFrameElement) {
                $('.about-us__youtubeVideoContainer').each(function() {
                    let iframe = $(this).find('iframe')[0];
                    if (iframe === document.activeElement && !youTubeVideoPlayed) {
                        countClickOnElement($(this).data('category-id'), $(this).data('element-id'));
                        youTubeVideoPlayed = true;
                    }
                });
            }
        }, 0);
    });
});

(function() {
    if (topProductsPerView > 0) {
        var topProductsSwiper = new Swiper('.mainPage__topSaleProducts .swiper-container', {
            slidesPerView: 1,
            navigation: {
                nextEl: '.product-top.swiper-button-next',
                prevEl: '.product-top.swiper-button-prev'
            },
            breakpoints: {
                500: {
                    slidesPerView: 2,
                },
                700: {
                    slidesPerView: 3,
                },
                900: {
                    slidesPerView: 4,
                },
                1400: {
                    slidesPerView: topProductsPerView,
                },
            },
        });
    }

    var homeSwiperTop = new Swiper('.mainPage__sliderContainer .swiper-container', {
        loop: true,
        autoplay: {
            delay: 2000,
            disableOnInteraction: true
        },
        preloadImages: false,
        lazy: true,
        speed: 500,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
    });

    var popularProductsCategories = new Swiper('.main-page-product-slider__slider-container .swiper-container', {
        loop: true,
        autoplay: {
            delay: 2000,
            disableOnInteraction: true
        },
        preloadImages: false,
        lazy: true,
        speed: 500,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
    });

    var inspirationImages = new Swiper('.main-page-inspiration-images__slider-container .swiper-container', {
        slidesPerView: 4,
        spaceBetween: 10,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            580: {
                slidesPerView: 1,
            },
            780: {
                slidesPerView: 2,
            },
            2000: {
                slidesPerView: 3,
            },
        }
    });
})()
